import "./BlogHero.css";
import { useState, useEffect } from "react";
import { useTranslation } from "../i18n";

function BlogHero() {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
        
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile(); // Verifica al cargar

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <>
            {isMobile ? (
                <>
                    <div className="blog-hero">
                        <div className="overlay"></div>
                        <div className="blog-hero-content">
                            <h2>{t("blog.heroKicker")}</h2>
                            <h1>{t("blog.heroTitleMobile")}</h1>
                            <p>{t("blog.heroTextMobile")}</p>
                            <a href="#blog-posts" className="blog-button">{t("common.readMore")}</a>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="blog-hero">
                        <div className="overlay"></div>
                        <div className="blog-hero-content">
                            <h2>{t("blog.heroKicker")}</h2>
                            <h1>{t("blog.heroTitle")}</h1>
                            <p>{t("blog.heroText")}</p>
                            <a href="#blog-posts" className="blog-button">{t("common.readMore")}</a>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default BlogHero;
